import ReactDOM from 'react-dom'
import { Builder } from 'apps/studio'
import 'apps/studio/styles/styles.scss'

ReactDOM.render(<Builder />, document.querySelector('#root'))
